// extracted by mini-css-extract-plugin
module.exports = {"root":"GraphQLQueryVariables_root__2gW0_"};